"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var html_definitions_1 = require("./html-definitions");
var SettingsComponent = /** @class */ (function () {
    function SettingsComponent() {
        var _this = this;
        this.slidefont = 0;
        this.uifont = 0;
        this.view =
            window.rslidy.utils.prependHtmlString(document.body, html_definitions_1.settings_html);
        // Parse default font sizes, in case the slide creator changes them
        this.default = window.rslidy.utils.getEM("#rslidy-content-section .slide");
        this.default_ui = window.rslidy.utils.getEM(".rslidy-ui");
        this.default_footer = window.rslidy.utils.getEM("#rslidy-footer");
        this.view
            .querySelector("#rslidy-button-font-plus")
            .addEventListener("click", function (e) { return _this.changeSlideFont(e, 1); });
        this.view
            .querySelector("#rslidy-button-font-reset")
            .addEventListener("click", function (e) { return _this.changeSlideFont(e, 0); });
        this.view
            .querySelector("#rslidy-button-font-minus")
            .addEventListener("click", function (e) { return _this.changeSlideFont(e, -1); });
        this.view
            .querySelector("#rslidy-button-font-plus-ui")
            .addEventListener("click", function (e) { return _this.changeUIFont(e, 1); });
        this.view
            .querySelector("#rslidy-button-font-reset-ui")
            .addEventListener("click", function (e) { return _this.changeUIFont(e, 0); });
        this.view
            .querySelector("#rslidy-button-font-minus-ui")
            .addEventListener("click", function (e) { return _this.changeUIFont(e, -1); });
        this.view
            .querySelector("#rslidy-checkbox-tilt")
            .addEventListener("click", function (e) { return window.rslidy.toolbar.closeMenuOnSelection(); });
        this.view
            .querySelector("#rslidy-checkbox-shake")
            .addEventListener("click", function (e) { return window.rslidy.toolbar.closeMenuOnSelection(); });
        this.view
            .querySelector("#rslidy-checkbox-space")
            .addEventListener("click", function (e) { return window.rslidy.toolbar.closeMenuOnSelection(); });
        this.view
            .querySelector("#rslidy-checkbox-margintap")
            .addEventListener("click", function (e) { return window.rslidy.toolbar.closeMenuOnSelection(); });
        this.view
            .querySelector("#rslidy-checkbox-lowlightmode")
            .addEventListener("click", function (e) {
            return window.rslidy.toolbar.closeMenuOnSelection(function () { return window.rslidy.toggleLowLightMode(); });
        });
    }
    // ---
    // Description: Load settings from the localStorage
    // ---
    SettingsComponent.prototype.loadSettings = function () {
        try {
            var item = localStorage.getItem("rslidy");
        }
        catch (e) {
            console.log(e);
            return;
        }
        if (item === null || item === undefined)
            return;
        var data = JSON.parse(item);
        if (data.slidefont != undefined)
            while (data.slidefont != this.slidefont)
                this.changeSlideFont(null, data.slidefont > 0 ? 1 : -1);
        if (data.uifont != undefined)
            while (data.uifont != this.uifont)
                this.changeUIFont(null, data.uifont > 0 ? 1 : -1);
        this.view.querySelector("#rslidy-checkbox-tilt").checked = data.tilt;
        this.view.querySelector("#rslidy-checkbox-shake").checked = data.shake;
        this.view.querySelector("#rslidy-checkbox-space").checked = data.space;
        this.view.querySelector("#rslidy-checkbox-margintap").checked = data.margintap;
        this.view.querySelector("#rslidy-checkbox-lowlightmode").checked = data.lowlightmode;
        if (data.lowlightmode)
            window.rslidy.toggleLowLightMode();
    };
    // ---
    // Description: Save settings to the localStorage
    // ---
    SettingsComponent.prototype.saveSettings = function () {
        try {
            localStorage.removeItem("rslidy");
            localStorage.setItem("rslidy", this.generateJSON());
        }
        catch (e) {
            console.log(e);
        }
    };
    // ---
    // Description: Generate a JSON string for the localStorage
    // ---
    SettingsComponent.prototype.generateJSON = function () {
        var data = {
            slidefont: this.slidefont,
            uifont: this.uifont,
            tilt: this.view.querySelector("#rslidy-checkbox-tilt").checked,
            shake: this.view.querySelector("#rslidy-checkbox-shake").checked,
            space: this.view.querySelector("#rslidy-checkbox-space").checked,
            margintap: this.view.querySelector("#rslidy-checkbox-margintap").checked,
            lowlightmode: this.view.querySelector("#rslidy-checkbox-lowlightmode").checked
        };
        return JSON.stringify(data);
    };
    // ---
    // Description: Used for final style adaptions.
    // ---
    SettingsComponent.prototype.doCustomSettingAdaptions = function () {
        // Start in night mode if set or user prefers it
        // Currently low light mode is broken in firefox mobile
        // filter:invert() causes the page to overflow
        // add "|| window.matchMedia("(prefers-color-scheme: dark)").matches"
        // to auto-enable low light mode once its fixed
        if (window.rslidy.start_in_low_light_mode) {
            var lowlightbtn = document.getElementById("rslidy-checkbox-lowlightmode");
            if (!lowlightbtn.checked) {
                window.rslidy.toggleLowLightMode();
                lowlightbtn.checked = true;
            }
        }
        // Block slide text selection if set
        if (window.rslidy.block_slide_text_selection) {
            var content_section = document.getElementById("rslidy-content-section");
            var original_slides = content_section.getElementsByClassName("slide");
            for (var i = 0; i < original_slides.length; i++)
                original_slides[i].classList.add("rslidy-noselect");
        }
    };
    // ---
    // Description: Called whenever one of the text size buttons is clicked.
    // e: The event.
    // value: Specifies the size modifier (1 = more, -1 = less).
    // ---
    SettingsComponent.prototype.changeSlideFont = function (e, value) {
        if (value == 0)
            this.slidefont = 0;
        else
            this.slidefont += value;
        var slides_large = document.querySelectorAll("#rslidy-content-section .slide");
        for (var i = 0; i < slides_large.length; i++) {
            if (value == 0)
                slides_large[i].style.fontSize = this.default + "em";
            var current_font_size = parseFloat(slides_large[i].style.fontSize);
            if ((current_font_size > window.rslidy.min_slide_font && value == -1) ||
                (current_font_size < window.rslidy.max_slide_font && value == 1))
                slides_large[i].style.fontSize =
                    current_font_size + window.rslidy.font_step * value + "em";
            else if (isNaN(current_font_size))
                slides_large[i].style.fontSize =
                    this.default + window.rslidy.font_step * value + "em";
        }
        // Prevent default actions after event handling
        if (e)
            e.preventDefault();
    };
    // ---
    // Description: Called whenever one of the text size buttons is clicked.
    // e: The event.
    // value: Specifies the size modifier (1 = more, -1 = less).
    // ---
    SettingsComponent.prototype.changeUIFont = function (e, value) {
        var _this = this;
        if (value == 0)
            this.uifont = 0;
        else
            this.uifont += value;
        var ui = document.querySelectorAll(".rslidy-ui");
        var footer = document.querySelector("#rslidy-footer");
        for (var i = 0; i < ui.length; i++) {
            if (value == 0)
                ui[i].style.fontSize = this.default_ui + "em";
            var current_font_size = parseFloat(ui[i].style.fontSize);
            if ((current_font_size > window.rslidy.min_slide_font && value == -1) ||
                (current_font_size < window.rslidy.max_slide_font && value == 1))
                ui[i].style.fontSize =
                    current_font_size + window.rslidy.font_step * value + "em";
            else if (isNaN(current_font_size))
                ui[i].style.fontSize =
                    this.default_ui + window.rslidy.font_step * value + "em";
        }
        // Prevent footer from overflowing, if on smaller screens
        if (this.default_footer < 1 &&
            parseFloat(footer.style.fontSize) > this.default_footer)
            footer.style.fontSize = this.default_footer + "em";
        setTimeout(function () { _this.checkToolbarOverflow(); }, 1000);
        // Prevent default actions after event handling
        if (e)
            e.preventDefault();
    };
    // ---
    // Description: Checks the toolbar for overflow and scales it down if needed.
    // ---
    SettingsComponent.prototype.checkToolbarOverflow = function () {
        // check if footer is still on the same line
        var ov = document.querySelector("#rslidy-button-overview").getBoundingClientRect();
        var toc = document.querySelector("#rslidy-button-toc").getBoundingClientRect();
        console.log(ov.top + " - " + toc.top);
        if (ov.top == toc.top)
            return;
        else
            this.changeUIFont(null, -1);
    };
    return SettingsComponent;
}());
exports.SettingsComponent = SettingsComponent;
